import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import TicketsTable from '../../TicketsTable/TicketsTable';
import { rowsFiltersForTicketHistoricState } from '../WagonDetailsPageSlice';

const headCells = [
  { id: 'ticketNumber', numeric: true, label: 'Ticket ID' },
  { id: 'ticketCreationDate', numeric: false, label: 'Ticket creation date' },
  { id: 'ticketClosingDate', numeric: true, label: 'Ticket closing date' },
  { id: 'plannedType', numeric: false, label: 'Type' },
  { id: 'ticketStatus', numeric: false, label: 'Ticket status' },
  { id: 'siteConcerned', numeric: false, label: 'Site concerned' },
  { id: 'wagonStatus', numeric: false, label: 'Wagon status' },
  { id: 'loadedStatus', numeric: false, label: 'Loaded status' },
  { id: 'priority', numeric: true, label: 'Priority' },
  { id: 'damageCodes', numeric: false, label: 'Damage codes' },
  { id: 'damagePlace', numeric: false, label: 'Damage place' },
];

export default function TicketsHistoricTabContent(props) {
  const { ticketsHistoric } = props;
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(15);
  const rowsFilters = useSelector(rowsFiltersForTicketHistoricState);
  const [rowsFiltered, setRowsFiltered] = React.useState(ticketsHistoric);
  const { t } = useTranslation();

  useEffect(() => {
    setRowsFiltered(ticketsHistoric);
  }, [ticketsHistoric]);

  useEffect(() => {
    let result = ticketsHistoric;
    rowsFilters.map((item) => {
      if (item.selectedOptions.length > 0) {
        result = result.filter(
          (row) => item.selectedOptions.includes(t(row[item.cell])) === true,
        );
      }
      return true;
    });
    setPage(0);
    setRowsFiltered(result);
  }, [ticketsHistoric, rowsFilters]);

  function getRowsPerPage(newRowsPerPage) {
    setRowsPerPage(newRowsPerPage);
  }

  function getPage(newPage) {
    setPage(newPage);
  }

  return (
    <TicketsTable
      headCells={headCells}
      ticketList={ticketsHistoric}
      rows={rowsFiltered}
      count={rowsFiltered.length}
      rowsPerPage={rowsPerPage}
      page={page}
      setRowsPerPage={getRowsPerPage}
      setPage={getPage}
    />
  );
}
